export default function DailyWealthRotationPage() {
  return (
    <div>
      <h1>Daily Wealth Rotation</h1>
      <p>Welcome to the Daily Wealth Rotation page.</p>
    </div>
  );
}
